<template>
  <svg
    v-if="renderInline"
    :class="b({ [icon]: true })"
    :width="viewBox.width"
    :height="viewBox.height"
    :aria-hidden="!alt ? true : undefined"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    focusable="false"
    tabindex="-1"
  >
    <title v-if="alt">
      {{ alt }}
    </title>
    <use :xlink:href="`${spritePath}#${icon}`" />
  </svg>
  <img
    v-else
    :class="b({ [icon]: true })"
    :src="iconPath"
    :alt="alt"
    :aria-hidden="!alt ? true : undefined"
    :width="viewBox.width"
    :height="viewBox.height"
    tabindex="-1"
  />
</template>

<script lang="ts">
  import { PropType, defineComponent } from 'vue';
  import spritePath from '@/assets/icons.svg';
  import { Icon } from '@/types/icon';

  // type Setup = {};

  type Data = {
    spritePath: string;
  };

  type SpecificIconSizes = {
    [key: string]: number[];
  };

  type Size = {
    width: number;
    height: number;
  };

  const defaultSize = 24; // Keep size in sync with SCSS 'icon' mixin.
  const specificIconSizes: SpecificIconSizes = {
    play: [1024, 721],
  };

  /**
   * Places an svg sprite icon OR renders the icon url in case if it is an external icon.
   */
  export default defineComponent({
    name: 'e-icon-sprite',

    // components: {},
    // mixins: [],

    props: {
      /**
       * Name of the svg icon
       */
      icon: {
        type: String as PropType<Icon>,
        required: true,
      },

      /**
       * Sets the width and height of the svg icon.
       */
      size: {
        type: String,
        default: null,
      },

      /**
       * Switches between inline and image use of the icon.
       */
      inline: {
        type: Boolean,
        default: true,
      },

      /**
       * Allows to set an alt tag to the image.
       */
      alt: {
        type: String,
        default: null,
      },
    },

    // setup(): Setup {
    //   return {};
    // },
    data(): Data {
      return {
        spritePath,
      };
    },

    computed: {
      isExternalIcon(): boolean {
        return this.icon?.startsWith('/') || this.icon?.startsWith('http');
      },

      iconPath() {
        return this.isExternalIcon ? this.icon : `${this.spritePath}#${this.icon}`;
      },

      renderInline(): boolean {
        return this.isExternalIcon ? false : this.inline;
      },

      /**
       * Returns a viewBox definition object.
       *
       * @returns {Object}
       */
      viewBox(): Size {
        const { icon } = this;
        const [specificWidth, specificHeight] = specificIconSizes[icon] || [];
        const size = this.size?.split(' ').map((sizeParameter) => Number.parseInt(sizeParameter, 10)) || [defaultSize];
        const width = size[0] || defaultSize;
        let height = size[1];

        // Auto map height for non-square icons.
        if (!height && specificWidth && specificHeight) {
          height = (width / specificWidth) * specificHeight;
        }

        return {
          width,
          height: height || width,
        };
      },
    },
    // watch: {},

    // beforeCreate() {},
    // created() {},
    // beforeMount() {},
    // mounted() {},
    // beforeUpdate() {},
    // updated() {},
    // activated() {},
    // deactivated() {},
    // beforeUnmount() {},
    // unmounted() {},

    // methods: {},
    // render() {},
  });
</script>

<style lang="scss">
  // @use '@/setup/scss/variables';

  .e-icon-sprite {
    display: block;
    pointer-events: none;
    flex-shrink: 0;
    flex-grow: 0;
  }
</style>
